import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.trabalhadordesligamento.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.trabalhadordesligamento.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionPesquisa = ({dispatch},payload)=>{
    return serves.boletinstabela.pesquisa(payload).then(res => {
        dispatch('ActionSetBoletins',res)
    }).catch(err => {
        dispatch('ActionSetBoletins',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.trabalhadordesligamento.delete(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionDeletarRemoneracaoEmpresa = ({dispatch},payload)=>{
    return serves.trabalhadordesligamento.deleteremoneracaoempresa(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionDeletarValorCalculo = ({dispatch},payload)=>{
    return serves.trabalhadordesligamento.deletevalorcalculo(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.trabalhadordesligamento.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.trabalhadordesligamento.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionNumero = ({dispatch},payload)=>{
    return serves.boletinstabela.numero(payload).then(res => {
        dispatch('ActionSetNumero',res)
    }).catch(err => {
        dispatch('ActionSetNumero',err)
    })
}
export const ActionUpdateEvento2299 = ({dispatch},payload)=>{
    if (payload.evento === '2299') {
        return serves.trabalhadordesligamento.update2299(payload).then(res => {
            dispatch('ActionSetMsg',res)
        }).catch(err => {
            dispatch('ActionSetMsg',err)
        })
    }else{
        return serves.trabalhadordesligamento.update2399(payload).then(res => {
            dispatch('ActionSetMsg',res)
        }).catch(err => {
            dispatch('ActionSetMsg',err)
        })
    }
}
export const ActionDeleteEvento2299 = ({dispatch},payload)=>{
    if (payload.evento === '2299') {
    return serves.trabalhadordesligamento.delete2299(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
    }else{
        return serves.trabalhadordesligamento.delete2399(payload).then(res => {
            dispatch('ActionSetMsg',res)
        }).catch(err => {
            dispatch('ActionSetMsg',err)
        })
    }
}
export const ActionCadastroEvento2299 = ({dispatch},payload)=>{
    if (payload.evento == '2299') {
        return serves.trabalhadordesligamento.cadastra2299(payload).then(res => {
            dispatch('ActionSetMsg',res)
        }).catch(err => {
            dispatch('ActionSetMsg',err)
        })
    }else{
        return serves.trabalhadordesligamento.cadastra2399(payload).then(res => {
            dispatch('ActionSetMsg',res)
        }).catch(err => {
            dispatch('ActionSetMsg',err)
        })
    }

}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetBoletins = ({commit},payload) =>{
    commit(types.SET_BOLETINS,payload)
}
export const ActionSetNumero = ({commit},payload) =>{
    commit(types.SET_NUMERO,payload)
}
